import { gql } from "@apollo/client";

export const MUTATION_CREATE_CARRIER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateCarrierFundingRequest(
    $amount: Int
    $debtor: String
    $billToCompanyPhone: String
    $billToCompanyEmail: String
    $streetOne: String
    $city: String
    $state: String
    $zip: String
    $country: String
    $userLoadNumber: String
    $fuelAdvanceAmount: Int
    $nonFactored: Boolean
  ) {
    createOrUpdateCarrierFundingRequest(
      input: {
        amount: $amount
        debtor: $debtor
        billToCompanyPhone: $billToCompanyPhone
        billToCompanyEmail: $billToCompanyEmail
        billToAddress: {
          streetOne: $streetOne
          city: $city
          state: $state
          zip: $zip
          country: $country
        }
        userLoadNumber: $userLoadNumber
        paymentMethod: "ach"
        fuelAdvanceAmount: $fuelAdvanceAmount
        nonFactored: $nonFactored
        contractType: "STD_CARRIER"
      }
    ) {
      fundingRequest {
        id
      }
    }
  }
`;

export const MUTATION_UPDATE_CARRIER_FUNDING_REQUEST = gql`
  mutation CreateOrUpdateCarrierFundingRequest(
    $id: ID
    $amount: Int
    $debtor: String
    $userLoadNumber: String
    $billToCompanyPhone: String
    $billToCompanyEmail: String
    $streetOne: String
    $city: String
    $state: String
    $zip: String
    $country: String
    $fuelAdvanceAmount: Int
    $nonFactored: Boolean
    $originLocations: LoadLocationInputType
    $destinationLocations: LoadLocationInputType
  ) {
    createOrUpdateCarrierFundingRequest(
      input: {
        id: $id
        amount: $amount
        debtor: $debtor
        userLoadNumber: $userLoadNumber
        billToCompanyPhone: $billToCompanyPhone
        billToCompanyEmail: $billToCompanyEmail
        billToAddress: {
          streetOne: $streetOne
          city: $city
          state: $state
          zip: $zip
          country: $country
        }
        fuelAdvanceAmount: $fuelAdvanceAmount
        nonFactored: $nonFactored
        contractType: "STD_CARRIER"
        firstOriginLocation: $originLocations
        finalDestinationLocation: $destinationLocations
      }
    ) {
      fundingRequest {
        id
      }
    }
  }
`;
